import React, { useState } from "react";
import "./../../../../assets/css/general/blog/NewsLetterSection/NewsLetterSection.css";

const NewsletterSection = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Subscribing email:", email);
    setEmail("");
  };

  return (
    <section className="newsletter-subscribe-section">
      <div className="newsletter-subscribe-container">
        <h2 className="newsletter-subscribe-title">
          Stay Ahead{" "}
          <span className="newsletter-subscribe-prefix">in Tech.</span>
        </h2>
        <p className="newsletter-subscribe-subtitle">
          Get weekly coding tutorials, AI insights, interview prep tips and
          roadmap updates directly from our mentors.
        </p>

        <form className="newsletter-subscribe-form" onSubmit={handleSubmit}>
          <div className="newsletter-subscribe-input-wrapper">
            <input
              type="email"
              className="newsletter-subscribe-input"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              aria-label="Email address"
            />
            <button type="submit" className="newsletter-subscribe-button">
              Subscribe Now →
            </button>
          </div>
        </form>

        <div className="newsletter-subscribe-trust">
          <div className="newsletter-trust-item">
            <svg
              className="newsletter-trust-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>No spam</span>
          </div>
          <div className="newsletter-trust-item">
            <svg
              className="newsletter-trust-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>Unsubscribe anytime</span>
          </div>
          <div className="newsletter-trust-item">
            <svg
              className="newsletter-trust-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>10,000+ developers already subscribed</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
